<template>
  <div id="app">
    <Header />
    <router-view :key="$route.fullPath" />
    <Footer />
  </div>
</template>

<script>
import Header from "@/layouts/components/header/HeaderComponent.vue";
import Footer from "@/layouts/components/footer/FooterComponent.vue";

export default {
  name: "App",
  components: { Header, Footer },

  mounted() {
    this.hidePreloaderWhenReady();
  },

  watch: {
    $route() {
      this.$nextTick(() => {
        if (window.WOW) {
          new window.WOW().init();
        }
      });
    }
  },

  methods: {
    async hidePreloaderWhenReady() {
      const preloader = document.getElementById("preloader");
      if (!preloader) return;

      // Ensure preloader is visible
      preloader.style.display = "flex";
      preloader.style.opacity = "1";

      // Wait for all images in #app to finish loading
      const images = Array.from(document.querySelectorAll("#app img"));
      await Promise.all(
        images.map(img => {
          if (img.complete) return Promise.resolve();
          return new Promise(resolve => {
            img.onload = img.onerror = resolve;
          });
        })
      );

      // wait a tiny delay for smooth transition
      await new Promise(resolve => setTimeout(resolve, 200));

      // 3️⃣ Fade out preloader
      preloader.style.opacity = "0";
      setTimeout(() => {
        preloader.style.display = "none";
      }, 500);
    }
  }
};
</script>
